module.exports = __webpack_public_path__ + "img/camera.82410950.svg";